"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-8579107e"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "oplus-table-wrapper" };
const _hoisted_2 = { class: "oplus-table oplus-table-hover" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("thead", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("tr", null, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", {
            class: "role-section-edit-cell",
            rowspan: "2"
        }, "編集"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", {
            class: "role-section-name-cell",
            rowspan: "2"
        }, "業務名"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "role-section-edit-cell" }, "休憩"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "role-section-edit-cell" }, "シフト表に表示"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", {
            class: "delete-btn-cell role-section-edit-cell",
            rowspan: "2"
        })
    ])
], -1 /* HOISTED */));
const _hoisted_4 = { href: "#" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "roles-name-cell d-flex flex-center" };
const _hoisted_7 = {
    key: 0,
    class: "zmdi zmdi-check zmdi-hc-lg text-success"
};
const _hoisted_8 = {
    key: 1,
    class: "zmdi zmdi-close zmdi-hc-lg text-error"
};
const _hoisted_9 = {
    key: 0,
    class: "zmdi zmdi-check zmdi-hc-lg text-success"
};
const _hoisted_10 = {
    key: 1,
    class: "zmdi zmdi-close zmdi-hc-lg text-error"
};
const _hoisted_11 = { class: "delete-btn-cell" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const KebabMenuIcon_vue_1 = __importDefault(require("../../vue/icons/KebabMenuIcon.vue"));
const DeleteIcon_vue_1 = __importDefault(require("../../vue/icons/DeleteIcon.vue"));
const EditIcon_vue_1 = __importDefault(require("../../vue/icons/EditIcon.vue"));
const vue_3 = require("vue");
const common_1 = require("../../js/common");
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
const roles_1 = require("../../js/roles");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleSectionTable',
    props: {
        isRoleSectionTableLoading: Boolean,
    },
    emits: ["role-section-on-delete", "role-section-on-edit"],
    setup(__props, { emit: __emit }) {
        const roleSectionArray = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleSectionArray) || [];
        const props = __props;
        const emitToContent = __emit;
        const data = (0, vue_3.ref)({
            selectedRoleId: "",
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": props.isRoleSectionTableLoading
            };
        });
        // unused functions for now at the moment
        // ** start **
        function roleStartTime(role) {
            const startHour = (0, common_1.addZeroPlaceholders)(role.getStartHour());
            const startMinute = (0, common_1.addZeroPlaceholders)(role.getStartMinute());
            return `${startHour}:${startMinute}`;
        }
        function roleEndTime(role) {
            const endHour = (0, common_1.addZeroPlaceholders)(role.getEndHour());
            const endMinute = (0, common_1.addZeroPlaceholders)(role.getEndMinute());
            return `${endHour}:${endMinute}`;
        }
        function renderRoleLabel(role) {
            const startTime = roleStartTime(role);
            const endTime = roleEndTime(role);
            return `${startTime} ~ ${endTime}`;
        }
        // ** end **
        function showDeleteButton(roleId) {
            data.value.selectedRoleId = roleId;
        }
        function handleRoleSectionDelete(roleId) {
            (0, roles_1.openConfirmModal)("割り当てている全ての業務から削除されますが、よろしいですか？", () => {
                emitToContent('role-section-on-delete', roleId);
            });
        }
        function handleRoleSectionEdit(roleId) {
            emitToContent('role-section-on-edit', roleId);
        }
        function roleColor(role) {
            return {
                'color': role.color ? "#fff" : "",
                'background-color': role.color ? `#${role.color}` : "",
                'border-radius': "3px",
            };
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createCommentVNode)(" Role Sections List "),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("table", _hoisted_2, [
                        _hoisted_3,
                        (0, vue_2.createElementVNode)("tbody", null, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(roleSectionArray), (role) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                    key: role.getId()
                                }, [
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("a", _hoisted_4, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "svg-container oplus-icon",
                                                onClick: ($event) => (handleRoleSectionEdit(role.getId()))
                                            }, [
                                                (0, vue_2.createVNode)(EditIcon_vue_1.default)
                                            ], 8 /* PROPS */, _hoisted_5)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                            (0, vue_2.createElementVNode)("span", {
                                                class: "role-name text-popup px-2",
                                                style: (0, vue_2.normalizeStyle)(roleColor(role))
                                            }, (0, vue_2.toDisplayString)(role.getName()), 5 /* TEXT, STYLE */)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (role.isRestSection)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_7))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_8))
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (role.showCount)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_9))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_10))
                                    ]),
                                    (0, vue_2.createCommentVNode)(" 3 dots button "),
                                    (0, vue_2.createElementVNode)("td", _hoisted_11, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", {
                                            class: (0, vue_2.normalizeClass)(["delete-icon-container svg-container oplus-icon", loadingClass.value]),
                                            onClick: ($event) => (handleRoleSectionDelete(role.getId()))
                                        }, [
                                            (0, vue_2.createVNode)(DeleteIcon_vue_1.default, { class: "delete-icon" })
                                        ], 10 /* CLASS, PROPS */, _hoisted_12), [
                                            [vue_2.vShow, role.getId() === data.value.selectedRoleId]
                                        ]),
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "svg-container oplus-icon",
                                            onClick: ($event) => (showDeleteButton(role.getId()))
                                        }, [
                                            (0, vue_2.createVNode)(KebabMenuIcon_vue_1.default)
                                        ], 8 /* PROPS */, _hoisted_13)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
